import { render, staticRenderFns } from "./problemsModal.vue?vue&type=template&id=d2e4d66c&"
import script from "./problemsModal.vue?vue&type=script&lang=js&"
export * from "./problemsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports